import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SeoMeta from '../Components/SeoMeta';
import './AboutUs.css';

const AboutUs = () => {
    const location = useLocation();
    const canonicalUrl = `https://www.nimantrana.co.in${location.pathname || '/about-us'}`;

    return (
        <div className="about-page">
            <SeoMeta
                title="About Us | Hotel Nimantrana"
                description="Discover Hotel Nimantrana - an invitation to warmth, elegance, and genuine hospitality. Luxury, comfort, and affordability combined."
                canonical={canonicalUrl}
            />
            <NavBar />
            
            {/* Hero Section */}
            <div className="about-hero">
                <div className="about-hero-content">
                    <h1>About Nimantrana</h1>
                    <p>An Invitation to Experience Warmth, Elegance, and Genuine Hospitality</p>
                </div>
            </div>

            <div className="about-container">
                {/* Section 1: Introduction */}
                <div className="about-section">
                    <div className="about-text">
                        <h2>Our Essence</h2>
                        <p>
                            The name <span className="highlight">“Nimantrana”</span> means an invitation—an invitation to experience warmth, elegance, and genuine hospitality. It reflects our belief in welcoming every guest not just as a visitor, but as an honored invitee, ensuring comfort, care, and a memorable stay from the moment you arrive.
                        </p>
                        <p>
                            Hotel Nimantrana is thoughtfully designed to offer a delightful stay experience with the essence of a five-star lifestyle at a budget-friendly price. We bring together luxury, comfort, and affordability, allowing guests to enjoy premium hospitality without compromise.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/aboutus5.jpg" alt="Nimantrana Interior" />
                    </div>
                </div>

                {/* Section 2: For Everyone */}
                <div className="about-section reverse">
                    <div className="about-text">
                        <h2>For Every Traveler</h2>
                        <p>
                            Whether you are a leisure traveler seeking relaxation, a corporate professional on a business trip, or a team looking for well-appointed meeting spaces, Hotel Nimantrana caters to all. Our stylish rooms, modern amenities, and elegant interiors are curated to provide a seamless balance of sophistication and convenience.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/cityView1.jpg" alt="Luxury Room" />
                    </div>
                </div>

                {/* Section 3: Conclusion */}
                <div className="about-section">
                    <div className="about-text">
                        <h2>More Than a Stay</h2>
                        <p>
                            With luxurious yet affordable rooms, premium amenities, and well-equipped meeting facilities, Hotel Nimantrana is ideal for both business and leisure stays. Every detail is crafted to create an environment where guests can relax, work, and connect effortlessly.
                        </p>
                        <p>
                            Hotel Nimantrana is more than just a place to stay—it is an experience where luxury is accessible, comfort is assured, and every guest feels truly invited.
                        </p>
                    </div>
                    <div className="about-image">
                         <img src="https://nimantrana-media.s3.ap-south-1.amazonaws.com/cityView3.jpg" alt="Hotel Amenities" />
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AboutUs;
